import React from "react";
import { CONFIG } from "../../utils/config";
import "./Promo.css";

const Promo: React.FC = () => {
  return (
    <section id="promo" className="promo-section">
      <div className="container promo-container">
        <div className="section-meta section-meta--orange">서비스</div>
        <h2 className="section-title">
          기억의 서랍은 소중한 이야기를 책으로 만듭니다.
        </h2>
        <p className="section-subtitle">
          편안하게 대화하고 평생의 기억을 완성해보세요.
          <br />
          가족과 함께하는 특별한 추억으로 만들어 드릴게요.
        </p>
        <div className="promo-video-container">
          <img
            src={CONFIG.IMAGES.PROMO_VIDEO}
            alt="서비스 소개 영상"
            className="promo-video"
          />
        </div>
      </div>
    </section>
  );
};

export default Promo;
